import { render } from "./HeroiconsSolidPlay.vue?vue&type=template&id=5193134f"
const script = {}

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPlay.vue"]])

export default __exports__